import {
  Box,
  Button,
  Card,
  CardContent,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { signOut } from "aws-amplify/auth";
import LogoutIcon from "@mui/icons-material/Logout";
import { useLocation, useNavigate } from "react-router-dom";
import { RoutesConfig } from "../router/types";
import { useUserStore } from "../store/userStore";

interface SearchProcessCardProps {
  onSearch?: (filters: any) => void;
}

const AdminMenu: React.FC<SearchProcessCardProps> = (
  props: SearchProcessCardProps
) => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Função para verificar se o caminho está ativo
  const isActive = (path: string) => location.pathname === path;

  // Função para obter as cores dinamicamente
  const getButtonStyles = (path: string) => {
    const isActivePath = isActive(path);
    return {
      backgroundColor: isActivePath ? "#326AFD" : "#fff",
      hoverBackgroundColor: isActivePath ? "#3a65d6" : "#f0f0f0",
      textColor: isActivePath ? "#fff" : "#0A0C33", // Cor do texto quando não ativo
      iconColor: isActivePath ? "#fff" : "#0A0C33", // Cor do ícone quando não ativo
      borderColor: isActivePath ? "#326AFD" : "#0A0C33",
    };
  };

  // Lidar com logout
  const handleLogout = async () => {
    try {
      await signOut({ global: true });
      useUserStore.getState().clearUserData();
      console.log("Usuário deslogado com sucesso");
      window.location.href = "/login";
    } catch (error) {
      console.error("Erro ao deslogar:", error);
    }
  };

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: { xs: "180px", sm: "180px", md: "80%" },
        boxShadow: "none",
        marginTop: "33px",
        marginBottom: "69px",
        borderRadius: "17px",
        border: "1px solid #0A0C33",
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          padding: 2,
          borderRadius: "15px",
          width: "auto",
          backgroundColor: "#fff",
          flex: 1,
        }}
      >
        <Button
          fullWidth
          onClick={() => navigate(RoutesConfig.HOME.path)}
          sx={{
            justifyContent: "flex-start",
            textTransform: "none",
            fontWeight: "bold",
            fontSize: "16px",
            borderRadius: "10px",
            color: getButtonStyles(RoutesConfig.HOME.path).textColor,
            backgroundColor: getButtonStyles(RoutesConfig.HOME.path)
              .backgroundColor,
            "&:hover": {
              backgroundColor: getButtonStyles(RoutesConfig.HOME.path)
                .hoverBackgroundColor,
            },
            padding: "10px 15px",
            border: `1px solid ${
              getButtonStyles(RoutesConfig.HOME.path).borderColor
            }`,
          }}
        >
          <InsertDriveFileIcon
            sx={{
              marginRight: 1,
              color: getButtonStyles(RoutesConfig.HOME.path).iconColor,
            }}
          />
          <span
            style={{ color: getButtonStyles(RoutesConfig.HOME.path).textColor }}
          >
            Processos
          </span>
        </Button>
        <Button
          fullWidth
          onClick={() => navigate(RoutesConfig.USUARIOS.path)}
          sx={{
            justifyContent: "flex-start",
            textTransform: "none",
            fontWeight: "bold",
            fontSize: "16px",
            borderRadius: "10px",
            color: getButtonStyles(RoutesConfig.USUARIOS.path).textColor,
            backgroundColor: getButtonStyles(RoutesConfig.USUARIOS.path)
              .backgroundColor,
            "&:hover": {
              backgroundColor: getButtonStyles(RoutesConfig.USUARIOS.path)
                .hoverBackgroundColor,
            },
            padding: "10px 15px",
            border: `1px solid ${
              getButtonStyles(RoutesConfig.USUARIOS.path).borderColor
            }`,
          }}
        >
          <PersonAddIcon
            sx={{
              marginRight: 1,
              color: getButtonStyles(RoutesConfig.USUARIOS.path).iconColor,
            }}
          />
          <span
            style={{
              color: getButtonStyles(RoutesConfig.USUARIOS.path).textColor,
            }}
          >
            Usuários
          </span>
        </Button>
      </CardContent>
      {!isMobile && (
        <Box
          component="footer"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 2,
            borderTop: "1px solid #eee",
          }}
        >
          <Button
            variant="text"
            sx={{
              color: "#326AFD",
              textTransform: "none",
              fontSize: "18px",
              fontWeight: "500",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
            onClick={handleLogout}
          >
            <LogoutIcon sx={{ transform: "rotate(180deg)" }} />
            Sair
          </Button>
        </Box>
      )}
    </Card>
  );
};

export default AdminMenu;
